// TekClap Mock Data

export const companyInfo = {
  name: "TekClap",
  tagline: "Applauding Technology",
  logo: "https://customer-assets.emergentagent.com/job_83f58cf4-8845-4128-a505-0ed372481ec0/artifacts/3c96zr88_logo.jpg",
  heroHeadline: "Technology, AI & Product Consulting That Scales",
  heroSubtext: "We help organizations modernize technology platforms, build AI-powered products, develop intelligent solutions, and scale their workforce effectively.",
  contact: {
    email: "info@tekclap.com",
    phone: "+1-908-791-1900",
    address: "3121 US 22, Branchburg, NJ 08876, United States"
  }
};

// Professional futuristic images
export const images = {
  hero: "https://images.unsplash.com/photo-1672581437674-3186b17b405a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxmdXR1cmlzdGljJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3Njg2NzAxMDR8MA&ixlib=rb-4.1.0&q=85",
  heroAlt: "https://images.unsplash.com/photo-1627645835237-0743e52b991f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxmdXR1cmlzdGljJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3Njg2NzAxMDR8MA&ixlib=rb-4.1.0&q=85",
  technologyConsulting: "https://images.unsplash.com/photo-1485740112426-0c2549fa8c86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxmdXR1cmlzdGljJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3Njg2NzAxMDR8MA&ixlib=rb-4.1.0&q=85",
  digitalTransformation: "https://images.unsplash.com/photo-1761912149936-8f662fc2a13e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxBSSUyMGRpZ2l0YWwlMjB0cmFuc2Zvcm1hdGlvbnxlbnwwfHx8fDE3Njg2NzAxMDh8MA&ixlib=rb-4.1.0&q=85",
  aiSolutions: "https://images.unsplash.com/photo-1768224656445-33d078c250b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxBSSUyMGRpZ2l0YWwlMjB0cmFuc2Zvcm1hdGlvbnxlbnwwfHx8fDE3Njg2NzAxMDh8MA&ixlib=rb-4.1.0&q=85",
  productDev: "https://images.unsplash.com/photo-1655393001768-d946c97d6fd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxmdXR1cmlzdGljJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3Njg2NzAxMDR8MA&ixlib=rb-4.1.0&q=85",
  talent: "https://images.unsplash.com/photo-1758691737387-a89bb8adf768?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwcHJvZmVzc2lvbmFscyUyMGNvbGxhYm9yYXRpb258ZW58MHx8fHwxNzY4NjcwMTEzfDA&ixlib=rb-4.1.0&q=85",
  partnership: "https://images.unsplash.com/photo-1758626038030-96f813504d15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxBSSUyMGRpZ2l0YWwlMjB0cmFuc2Zvcm1hdGlvbnxlbnwwfHx8fDE3Njg2NzAxMDh8MA&ixlib=rb-4.1.0&q=85"
};

export const stats = [
  { value: "25+", label: "Projects Delivered" },
  { value: "150+", label: "Experts" },
  { value: "3", label: "Global Regions" }
];

export const regions = ["North America", "Europe", "Asia"];

export const servicePillars = [
  {
    id: "technology-consulting",
    title: "Technology Consulting",
    description: "Digital transformation, agile execution, and strategic technology roadmapping for modern enterprises.",
    icon: "Cpu",
    link: "/technology-consulting",
    image: "https://images.unsplash.com/photo-1485740112426-0c2549fa8c86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxmdXR1cmlzdGljJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3Njg2NzAxMDR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "ai-consulting",
    title: "AI Consulting",
    description: "AI strategy, intelligent automation, and AI-enabled workflows that transform business operations.",
    icon: "Brain",
    link: "/ai-consulting",
    image: "https://images.unsplash.com/photo-1768224656445-33d078c250b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxBSSUyMGRpZ2l0YWwlMjB0cmFuc2Zvcm1hdGlvbnxlbnwwfHx8fDE3Njg2NzAxMDh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "product-development",
    title: "Product Development",
    description: "Cloud-native SaaS, web and mobile applications, and AI-powered product engineering.",
    icon: "Rocket",
    link: "/product-development",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&auto=format&fit=crop"
  },
  {
    id: "workforce-solutions",
    title: "Workforce & Talent Solutions",
    description: "Strategic staffing, RPO, and workforce modernization for the future of work.",
    icon: "Users",
    link: "/workforce-solutions",
    image: "https://images.unsplash.com/photo-1758691737387-a89bb8adf768?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwcHJvZmVzc2lvbmFscyUyMGNvbGxhYm9yYXRpb258ZW58MHx8fHwxNzY4NjcwMTEzfDA&ixlib=rb-4.1.0&q=85"
  }
];

export const whyTekClapSnapshot = [
  {
    title: "Technology Artistry Meets Human Empathy",
    description: "We blend technical excellence with deep understanding of business and human needs."
  },
  {
    title: "Long-Term Partnerships",
    description: "We invest in relationships, not just projects. Your success is our success."
  },
  {
    title: "Transparent Excellence",
    description: "Clear communication, honest assessments, and measurable outcomes at every step."
  }
];

export const technologyConsultingServices = {
  title: "Technology Consulting",
  intro: "Transform your technology landscape with strategic guidance and expert execution.",
  sections: [
    {
      title: "Digital & Agile Transformation",
      items: [
        "Digital strategy and modernization",
        "Agile execution and methodology implementation",
        "Technology roadmapping and architecture",
        "Change management and adoption"
      ]
    },
    {
      title: "High-Tech & Engineering Services",
      items: [
        "Software and platform engineering",
        "Embedded systems and IoT solutions",
        "Data and AI engineering",
        "Secure architecture design"
      ]
    },
    {
      title: "AI Strategy & Intelligent Automation",
      items: [
        "AI integration and implementation",
        "AI-enabled workflow optimization",
        "Embedded intelligent systems",
        "Machine learning operations (MLOps)"
      ]
    },
    {
      title: "Business Optimization & Advisory",
      items: [
        "Process optimization and reengineering",
        "Enterprise solution design",
        "Technology investment advisory",
        "Vendor selection and management"
      ]
    }
  ]
};

export const productAISolutions = {
  title: "Product & AI Solutions",
  intro: "Build products that matter with AI-driven development and cloud-native execution.",
  quote: "Our AI Arbitrage model leverages best-in-class AI technologies to deliver outcome-driven value efficiently.",
  sections: [
    {
      title: "Product Discovery & Cloud-Native Execution",
      items: [
        "Product strategy and roadmapping",
        "SaaS delivery and optimization",
        "Cloud-native architecture",
        "MVP development and validation"
      ]
    },
    {
      title: "AI-Powered Products & Optimization",
      items: [
        "AI agents and assistants",
        "AI arbitrage model implementation",
        "Predictive analytics solutions",
        "Intelligent automation products"
      ]
    },
    {
      title: "Custom Engineering & Integrations",
      items: [
        "API design and development",
        "Bespoke software solutions",
        "Secure system integrations",
        "Legacy system modernization"
      ]
    },
    {
      title: "Application Development",
      items: [
        "Web application development",
        "Mobile application development",
        "Full-stack solutions",
        "Progressive web apps (PWA)"
      ]
    }
  ]
};

export const talentWorkforceSolutions = {
  title: "Talent & Workforce Solutions",
  intro: "Build and scale your team with modern workforce strategies and expert talent acquisition.",
  sections: [
    {
      title: "Staffing Models",
      items: [
        "Staff augmentation",
        "Contract-to-hire placements",
        "Direct hire solutions",
        "Gig and project-based talent"
      ]
    },
    {
      title: "Leadership & Strategy",
      items: [
        "Fractional CXO services",
        "Senior specialist placement",
        "Leadership coaching",
        "Organizational design"
      ]
    },
    {
      title: "Talent Acquisition",
      items: [
        "Recruitment Process Outsourcing (RPO)",
        "AI-assisted recruitment",
        "Executive search",
        "Campus and early career hiring"
      ]
    },
    {
      title: "Workforce Development",
      items: [
        "Upskilling and reskilling programs",
        "Employee well-being initiatives",
        "Engagement and retention strategies",
        "Learning and development design"
      ]
    }
  ]
};

export const clientImpact = {
  metrics: [
    { value: "40%", label: "Productivity Boost", description: "Average improvement in team productivity" },
    { value: "50%", label: "Faster Testing Cycles", description: "Reduction in QA and testing time" },
    { value: "75%", label: "Hiring Time Reduction", description: "Faster time-to-hire with our solutions" },
    { value: "25+", label: "Projects Delivered", description: "Successful engagements completed" }
  ],
  caseStudies: [
    {
      title: "Legacy Modernization",
      description: "Transformed a 15-year-old monolithic system into a modern microservices architecture, reducing operational costs by 40%.",
      industry: "Financial Services"
    },
    {
      title: "QA Automation Excellence",
      description: "Implemented comprehensive test automation framework, achieving 50% faster release cycles with improved quality.",
      industry: "Healthcare Technology"
    },
    {
      title: "Rapid Team Scaling",
      description: "Scaled engineering team from 10 to 50 specialists in 3 months while maintaining culture fit and technical excellence.",
      industry: "E-Commerce"
    }
  ]
};

export const whyTekClap = {
  differentiators: [
    {
      title: "Technology Artistry Meets Human Empathy",
      description: "We don't just deliver technology—we understand the human side of transformation. Our solutions are designed with the end user in mind."
    },
    {
      title: "Long-Term Partnerships",
      description: "We measure our success by your success. Our engagement model is built for sustained value, not quick wins that fade."
    },
    {
      title: "Transparent Delivery",
      description: "No hidden agendas, no surprise costs. We believe in clear communication and honest assessments throughout every engagement."
    },
    {
      title: "Measurable Business Value",
      description: "Every recommendation, every solution, every hire is tied to tangible business outcomes that you can measure and track."
    }
  ],
  promise: "We commit to being the partner you can trust—one who brings expertise, transparency, and genuine care to every engagement."
};

export const aboutInfo = {
  intro: "TekClap is a strategic consulting firm specializing in technology transformation, product innovation, and workforce modernization.",
  globalReach: {
    title: "Global Reach & Scale",
    description: "With delivery capabilities across North America, Europe, and Asia, we bring global expertise with local understanding.",
    regions: ["North America", "Europe", "Asia"]
  },
  teamSize: {
    value: "150+",
    label: "Experts",
    description: "A diverse team of consultants, engineers, and talent specialists ready to support your growth."
  },
  growthStory: "Founded with a vision to bridge the gap between technology potential and business reality, TekClap has grown into a trusted partner for enterprises seeking meaningful transformation.",
  clients: [
    { 
      name: "American Express", 
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/American_Express_logo_%282018%29.svg/512px-American_Express_logo_%282018%29.svg.png"
    },
    { 
      name: "Roche", 
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Hoffmann-La_Roche_logo.svg/512px-Hoffmann-La_Roche_logo.svg.png"
    },
    { 
      name: "Intuit", 
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Intuit_Logo.svg/512px-Intuit_Logo.svg.png"
    },
    { 
      name: "American Red Cross", 
      logo: "https://upload.wikimedia.org/wikipedia/commons/b/bb/American_Red_Cross_Logo.svg"
    }
  ]
};

export const contactForm = {
  title: "Schedule a Consultation",
  subtitle: "Let's build the future together.",
  fields: [
    { name: "name", label: "Name", type: "text", required: true },
    { name: "company", label: "Company", type: "text", required: true },
    { name: "email", label: "Email", type: "email", required: true },
    { name: "role", label: "Role", type: "text", required: false },
    { 
      name: "areaOfInterest", 
      label: "Area of Interest", 
      type: "select", 
      required: true,
      options: [
        "Technology Consulting",
        "Product & AI Solutions",
        "Talent & Workforce Solutions"
      ]
    },
    { name: "message", label: "Message", type: "textarea", required: false }
  ]
};

export const navigation = [
  { label: "Home", path: "/" },
  { 
    label: "Services", 
    path: "/services",
    children: [
      { label: "Technology Consulting", path: "/technology-consulting" },
      { label: "AI Consulting", path: "/ai-consulting" },
      { label: "Product Development", path: "/product-development" },
      { label: "Workforce Solutions", path: "/workforce-solutions" }
    ]
  },
  { label: "Client Impact", path: "/client-impact" },
  { label: "Industries", path: "/", hash: "#industries" },
  { label: "Why TekClap", path: "/why-tekclap" },
  { label: "About", path: "/about" },
  { label: "Careers", path: "/careers" },
  { label: "Contact", path: "/contact" }
];
